import RetailLeadForm from "../../calculators/retailLeadForm";
import Container from "react-bootstrap/Container";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import LandingHeader from "../../components/LandingHeader";
import List from "../../components/List";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";

export default function SzemelyiKolcson() {
  return (
    <>
      <LandingHeader
        title={
          <>
            Személyi kölcsön <br />
            <span style={{ color: "#c7d2fe" }}>kalkulátor</span>
          </>
        }
        subtitle={
          <span className="fw-bold">
            Használd kalkulátorunkat és kollégánk 24 órán belül keresni fog,
            hogy segítsen a hitel igénylésében!
          </span>
        }
        landingcontent={
          <List
            items={[
              <>
                Igényelhető hitelösszeg akár{" "}
                <strong style={{ color: "var(--title-color)" }}>
                  15 millió Ft
                </strong>
              </>,
              <>
                Folyósítás akár{" "}
                <strong style={{ color: "var(--title-color)" }}>
                  24 óra alatt
                </strong>
              </>,
              <>Ingatlanfedezet nélkül</>,
              <>
                <strong style={{ color: "var(--title-color)" }}>Online</strong>{" "}
                ügyintézés
              </>,
              <>
                <strong style={{ color: "var(--title-color)" }}>
                  Díjmentes
                </strong>{" "}
                tanácsadás
              </>,
            ]}
          />
        }
        calculator={<RetailLeadForm leadType="Personal_loan" />}
      />

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">Akár 10% alatti</div>
                <div className="muted">kamat</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Akár 15.000.000 Ft</div>
                <div className="muted">Igényelhető hitelösszeg</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Akár 24 órán</div>
                <div className="muted">belüli folyósítás</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2 text-center">
            Így működik a személyi kölcsön igénylése
          </h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Adatok megadása</p>
                <p className="small">
                  Add meg mekkora hitelösszegre lenne szükséges, mekkora
                  jövedelemmel rendelkezel, és, hogy milyen futamidőre gondoltál
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Kapcsolatfelvétel</p>
                <p className="small">
                  Kollégánk 24 órán belül felhív, és a telefonos egyeztetés
                  alapján küld egy összehasonlítást a számodra elérhető
                  ajánlatokról
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Összehasonlítás és döntés</p>
                <p className="small">
                  Az ajánlatok közül tanácsadónk segítségével ki tudod
                  választani a számodra megfelelő személyi kölcsön ajánlatot
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Szerződéskötés és folyósítás</p>
                <p className="small">
                  Ezt követően szakértő kollégáink segítenek az ügyintézésben,
                  és akár 24 órán belül már a számládon is lehet a kívánt
                  hitelösszeg.
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Mi számít jó THM-nek személyi kölcsönnél 2026-ban?",
                    answer:
                      "2026-ban egy 1-3 millió forintos, 36 hónapos személyi kölcsönnél a 10-15% közötti THM tekinthető versenyképesnek jó hiteltörténet mellett; 18% felett érdemes más bankok ajánlatát is megnézni. A THM mindig tartalmazza a kamatot és a legtöbb díjat is, ezért ez az elsődleges összehasonlítási alap, nem a hirdetett kamat.",
                  },
                  {
                    question: "Felvehetek személyi kölcsönt KHR-bejegyzéssel?",
                    answer:
                      "Aktív, negatív (B) KHR-listás státusszal a legtöbb hazai bank elutasítja a hiteligénylést, mivel a KHR-ellenőrzés kötelező eleme a bírálatnak. Lezárt, passzív KHR-bejegyzés esetén egyes bankok és pénzügyi vállalkozások továbbra is mérlegelik a kérelmet, magasabb kamat vagy alacsonyabb hitelösszeg mellett.",
                  },
                  {
                    question:
                      "Mennyi idő alatt bírálják el a személyi kölcsön kérelmet?",
                    answer:
                      "A legtöbb banknál a teljes online igénylési folyamat, a dokumentumfeltöltéstől a szerződéskötésig, 1-3 munkanapot vesz igénybe, hiánytalan papírok esetén. A folyósítás jellemzően a szerződés aláírását követő 1-2 munkanapon belül megtörténik, banki munkarendtől függően.",
                  },
                  {
                    question:
                      "Van különbség a szabad felhasználású és a hitelkiváltó kölcsön THM-je között?",
                    answer:
                      "Igen: a hitelkiváltó (más hitel kiváltására szánt) személyi kölcsönök THM-je jellemzően 1-3 százalékponttal alacsonyabb, mert a bank kockázata alacsonyabb, és sok intézmény kedvezményt ad a meglévő hitel kiváltására. Szabad felhasználásnál nincs ilyen automatikus kedvezmény.",
                  },
                  {
                    question:
                      "Milyen dokumentumok kellenek a személyi kölcsön igényléséhez?",
                    answer:
                      "Személyazonosító igazolvány, lakcímkártya és adókártya mellett jövedelemigazolás szükséges (munkáltatói igazolás vagy 3-6 havi bankszámlakivonat), valamint a bank saját igénylőlapja. Meglévő hitel kiváltásához a futó szerződés és az aktuális egyenlegigazolás is szükséges.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
